import fetchPosts from "common/fetch/fetchPosts";
import fetchSeo from "common/fetch/fetchSeo";

import Layout from "components/common/Layout";
import OffshoreCompanyFormation from "components/templates/offshore/company-formation";

import dataCompany from "./data";

export default function Home({ data }) {
  return (
    <div>
      <Layout locationRouter="offshore" page={data.page}>
        <OffshoreCompanyFormation data={data} dataJson={dataCompany} />
      </Layout>
    </div>
  );
}

export const getStaticProps = async () => {
  const locale = "offshore";
  const uri = "/company-formation";
  const page = await fetchSeo({
    uri,
    locale,
  });
  // Const res = await fetch(
  //   `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/trustpilot`
  // );
  // Const dataTrustpilot = await res.json();
  const dataTrustpilot = {
    state: true,
    data: {
      id: "582c07bf0000ff0005979466",
      displayName: "BBCIncorp Limited",
      identifyingName: "bbcincorp.com",
      referringNames: ["bbcincorp.com", "www.bbcincorp.com"],
      isClaimed: true,
      trustScore: "4.9",
      numberOfReviews: 404,
      hasReviews: true,
      numberOfReviewsThatCountTowardsTrustScore: 343,
      email: "service@bbcincorp.com",
      emailDomain: "bbcincorp.com",
      website: "https://bbcincorp.com",
      country: "Hong Kong",
    },
    message: "Successfully.",
  };
  const posts = await fetchPosts({
    postPerPage: 3,
    gqlNode: `
    categories {
      nodes {
        name
        uri
        parent {
          node {
            id
          }
        }
      }
    }`,
    locale,
    variables: [
      {
        name: "where",
        type: "RootQueryToPostConnectionWhereArgs",
        value: {
          in: [1082, 1090, 1225],
        },
      },
    ],
  });

  return {
    props: {
      data: {
        page: page || {},
        posts: posts?.nodes || [],
        dataTrustpilot,
      },
      revalidate: 1,
    },
  };
};
